import React, { Component } from 'react';
import { Button, ButtonGroup, Col, Form, Row, ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import DatePicker from 'react-datepicker';

class SearchForm extends Component<any, any> {

  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.setModality = this.setModality.bind(this);
    this.setStudyDate = this.setStudyDate.bind(this);
    this.handleStudyDateChange = this.handleStudyDateChange.bind(this);
  }

  setModality(e) {
    this.props.onChange('modality', e.target.name);
  }

  setStudyDate(e) {
    const date = new Date();
    switch (e.target.name) {
      case 'today':
        this.props.onChange('studyDate', this.formatDate(date));
        break;
      case 'yesterday':
        date.setDate(date.getDate() - 1);
        this.props.onChange('studyDate', this.formatDate(date));
        break;
      case 'anyday':
        this.props.onChange('studyDate', '');
        break;
      default:
        break;
    }
  }

  setAdvancedFieldsVisible(visible) {
    this.props.onChange('advanced', visible);
  }

  handleStudyDateChange(e) {
    if (!e) {
      this.props.onChange('studyDate', '');
    } else {
      this.props.onChange('studyDate', this.formatDate(new Date(e)));
    }
  }

  handleChange(e) {
    const field = e.target.name;
    const { value } = e.target;
    this.props.onChange(field, value);
  }

  handleSubmit(e) {
    e.preventDefault();
    let searchMode = e.nativeEvent.submitter.name;
    this.props.onSubmit(searchMode);
  }

  getYesterday() {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return yesterday;
  }

  formatDate(date: Date) {
    if (date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); 
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    }

    return '';
  }

  convertToDate(date:string) {
    if(date.length === 0)
      return undefined;

    const [day, month, year] = date.split('/').map(Number);
    return new Date(year, month - 1, day);
  }

  render() {
    const { firstName, lastName, modality } = this.props.fields;
    const { patientId, studyUid, accNum } = this.props.fields;
    const { advanced } = this.props.fields;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          {!advanced && (
            <React.Fragment>
              <Form.Group as={Col} sm={3}>
                <Form.Control
                  size="sm"
                  type="text"
                  value={lastName}
                  placeholder="Last name"
                  name="lastName"
                  onChange={this.handleChange}
                  tabIndex={1}
                />
              </Form.Group>
              <Form.Group as={Col} sm={3}>
                <Form.Control
                  size="sm"
                  type="text"
                  value={firstName}
                  placeholder="First name"
                  name="firstName"
                  onChange={this.handleChange}
                  tabIndex={2}
                />
              </Form.Group>
            </React.Fragment>
          )}

          {advanced && (
            <Form.Group as={Col} sm={6}>
              <Form.Control
                size="sm"
                type="text"
                value={patientId}
                placeholder="Patient ID"
                name="patientId"
                onChange={this.handleChange}
                tabIndex={1}
              />
            </Form.Group>
          )}

          <Col sm={4}>
            <ToggleButtonGroup
              type="checkbox"
              size="sm"
              value={advanced}
              onChange={e => this.setAdvancedFieldsVisible(!advanced)}
              style={{
                marginBottom: '0.5rem',
              }}
            >
              <ToggleButton variant="outline-secondary" value="">
                ID filters
              </ToggleButton>
            </ToggleButtonGroup>
          </Col>
        </Row>

        {!advanced && (
          <Row>
            <Form.Group as={Col} sm={6}>
              <Form.Control
                size="sm"
                type="text"
                value={modality}
                placeholder="Modality"
                name="modality"
                onChange={date => this.handleChange(date)}
                tabIndex={3}
              />
            </Form.Group>
            <Form.Group as={Col} sm={6}>
              <ButtonGroup size="sm">
                <Button name="CT" onClick={this.setModality} variant="outline-secondary" className={this.props.fields.modality === "CT" ? 'selected' : ''}>
                  CT
                </Button>
                <Button name="MR" onClick={this.setModality} variant="outline-secondary" className={this.props.fields.modality === "MR" ? 'selected' : ''}>
                  MR
                </Button>
                <Button name="MG" onClick={this.setModality} variant="outline-secondary" className={this.props.fields.modality === "MG" ? 'selected' : ''}>
                  MG
                </Button>
                <Button name="CR" onClick={this.setModality} variant="outline-secondary" className={this.props.fields.modality === "CR" ? 'selected' : ''}>
                  CR
                </Button>
                <Button name="DX" onClick={this.setModality} variant="outline-secondary" className={this.props.fields.modality === "DX" ? 'selected' : ''}>
                  DX
                </Button>
                <Button name="US" onClick={this.setModality} variant="outline-secondary" className={this.props.fields.modality === "US" ? 'selected' : ''}>
                  US
                </Button>
              </ButtonGroup>
            </Form.Group>
          </Row>
        )}

        {advanced && (
          <Row>
            <Form.Group as={Col} sm={6}>
              <Form.Control
                type="text"
                size="sm"
                value={studyUid}
                placeholder="Study Instance UID"
                name="studyUid"
                onChange={this.handleChange}
                tabIndex={3}
              />
            </Form.Group>
          </Row>
        )}

        {!advanced && (
          <Row>
            <Form.Group as={Col} sm={6}>
              <div>
                <DatePicker
                  selected={this.convertToDate(this.props.fields.studyDate)}
                  onChange={date => this.handleStudyDateChange(date)}
                  placeholderText="Study date"
                  tabIndex={4}
                  dateFormat="dd/MM/yyyy"
                  className="form-control form-control-sm"
                  formatWeekDay={(day: string) => day.substring(0, 3)}
                />
              </div>
            </Form.Group>
            <Form.Group as={Col} sm={6}>
              <ButtonGroup>
                <Button
                  name="today"
                  size="sm"
                  onClick={this.setStudyDate}
                  variant="outline-secondary"
                  className={this.props.fields.studyDate === this.formatDate(new Date()) ? 'selected' : ''}
                >
                  Today
                </Button>
                <Button
                  name="yesterday"
                  size="sm"
                  onClick={this.setStudyDate}
                  variant="outline-secondary"
                  className={this.props.fields.studyDate === this.formatDate(this.getYesterday()) ? 'selected' : ''}
                >
                  Yesterday
                </Button>
                <Button
                  name="anyday"
                  size="sm"
                  onClick={this.setStudyDate}
                  variant="outline-secondary"
                  className={!this.props.fields.studyDate ? 'selected' : ''}
                >
                  Any date
                </Button>
              </ButtonGroup>
            </Form.Group>
          </Row>
        )}

        {advanced && (
          <Row>
            <Form.Group as={Col} sm={6}>
              <Form.Control
                type="text"
                size="sm"
                value={accNum}
                placeholder="Accession Number"
                name="accNum"
                onChange={this.handleChange}
                tabIndex={4}
              />
            </Form.Group>
          </Row>
        )}

        <Row>
          <Col sm={2} style={{ marginBottom: '0.5em', textAlign: 'left' }}>
            <Button style={{ width: '9em' }} tabIndex={5} type="submit" variant="primary" name="local" size="sm">
              Search FEED
            </Button>
          </Col>
          {this.props.proxyConfiguration && this.props.proxyConfiguration.enabled === true && (
            <Col sm={2} style={{ marginBottom: '0.5em', textAlign: 'left' }}>
              <Button style={{ width: '9em' }} tabIndex={6} type="submit" variant="primary" name="remote" size="sm">
                Search PACS
              </Button>
            </Col>
          )}
        </Row>
      </Form>
    );
  }
}

export default SearchForm;
